import React from "react";
import { string, node, func } from "prop-types";

import { Link } from "react-router-dom";
import { Button } from "../../../../common/index";

const LinkButton = ({ route, children }) => (
  <div style={{ marginBottom: 15 }}>
    <Link
      to={route}
      className="btn-plain d-block text-info m-auto text-center"
      style={{ width: 264, marginBottom: 20 }}
    >
      {children}
    </Link>
  </div>
);

LinkButton.propTypes = {
  route: string.isRequired,
  children: node.isRequired,
};

export const AddAnotherButton = ({ toggleForm, children }) => (
  <div
    id="btn_add_another_work_history"
    style={{ display: "flex", justifyContent: "space-evenly" }}
  >
    <Button
      classes="btn btn-primary my-2 btn-block"
      styles={{ width: 264, margin: "auto" }}
      onClick={() => toggleForm(true)}
    >
      {children}
    </Button>
  </div>
);

AddAnotherButton.propTypes = {
  toggleForm: func.isRequired,
  children: node.isRequired,
};

const basicButtonPropTypes = {
  route: string.isRequired,
};

export const NextButton = ({ route }) => (
  <LinkButton route={route}>Next</LinkButton>
);

NextButton.propTypes = basicButtonPropTypes;

export const SkipButton = ({ route }) => (
  <LinkButton route={route}>Skip</LinkButton>
);

SkipButton.propTypes = basicButtonPropTypes;

export const SaveButton = ({ route }) => (
  <LinkButton route={route}>Save</LinkButton>
);

SaveButton.propTypes = basicButtonPropTypes;

export const DoneButton = ({ route }) => (
  <LinkButton route={route}>I&apos;m done</LinkButton>
);

DoneButton.propTypes = basicButtonPropTypes;
